import dom from "../../../dist/jsx-render/dom"
import JSXComponent from "../../../dist/jsx-render/JSXComponent"
import { MsoTable } from "./MsoTable";
import { ColumnBase } from "./ColumnBase";
import { ListItem } from "../../Model/ListItem";
import { TreeView, TreeViewProps } from "../../Components/TreeView/TreeView";
import { ITreeNodeModel } from "../../Components/TreeView/Models/Interfaces/ITreeNodeModel";
import { CheckedState } from "../../Components/TreeView/Models/enums/CheckedState";
import { DateLevelFilter } from "../../Components/TreeView/Modules/Filter/DateLevelFilter";


abstract class BaseFilterItem {
    value: string;
    name: string;
    level: number;

    constructor(value: string, name: string, level: number) {
        this.value = value;
        this.name = name;
        this.level = level;
    }
}

export class YearFilterItem extends BaseFilterItem {
    months: { [id: string]: MonthFilterItem };

    constructor(value: string, name: string) {
        super(value, name, 1);
        this.months = {};
    }
}

export class MonthFilterItem extends BaseFilterItem {
    days: { [id: string]: DayFilterItem };
    parent: YearFilterItem;

    constructor(value: string, name: string, parent: YearFilterItem) {
        super(value, name, 2);
        this.days = {};
        this.parent = parent;
    }
}

export class DayFilterItem extends BaseFilterItem {
    parent: MonthFilterItem;

    constructor(value: string, name: string, parent: MonthFilterItem) {
        super(value, name, 3);
        this.parent = parent;
    }
}


export class dateModel{
    text: string;
    value: string;
    childs: Array<dateModel> = [];
    level: number;
}

export type FilterDatePopupComponentProps = {
    table: MsoTable;
    column: ColumnBase;
}
export class FilterPopupDateTreeComponent extends JSXComponent {
    dateTreeView: TreeView;
    dateFilter: DateLevelFilter;
    props: FilterDatePopupComponentProps;
    years: { [id: string]: YearFilterItem } = {};
    model: dateModel;
    checkBoxList: Array<string> = [];
    existNull: boolean = false;

    constructor(props: FilterDatePopupComponentProps) {
        super(props);
        this.dateFilter = new DateLevelFilter();
    }

    render() {
        this.createContent();
        let contentTreeViewProps: TreeViewProps = {
            businessModel: this.model.childs,
            allowSelect: true,
            displayProperty: "text",
            childrenProperty: "childs",
            checkboxCheckedEvent: this.onCheckboxChecked,
            childrenCollapsed: true,
        }
        this.dateTreeView = new TreeView({ ...contentTreeViewProps });
        let element: HTMLElement =
            <div className="mt-tree">
                {this.dateTreeView.render()}
            </div>
        this.setInitialSelection();
        return element;
    }

    createContent() {
        this.props.column.getUniqueVisibleItems(this.props.table).map((item: ListItem) => {
            if (item.id != "null") {
                this.buildDateTree(item)
            }
            else
                this.existNull = true;
        })
        this.convertToDateModel();
    }

    onCheckboxChecked = (node: ITreeNodeModel, event: Event) => {
        if (node.businessModel) {
            if (node.businessModel.value == "@all@") {
                if (node.selected == CheckedState.Checked)
                    this.setAllChecked();
                else {
                    this.checkBoxList = [];
                    // uncheck all the year tree items
                    var items = this.dateTreeView.nodes.filter(u => u.props.model.level == 0 && u.props.model.businessModel.value != "@all@");
                    if (items && items.length > 0) {
                        for (let child of items) {
                            child.unselect(true, false);
                        }
                    }
                }
            }
            else {
                if (node.selected == CheckedState.Unchecked)
                    // ucheck "all" when unchecked one of year item
                    this.dateTreeView.nodes.filter(u => u.props.model.level == 0 && u.props.model.businessModel.value == "@all@")[0].unselect(true, false);
            }
        }
        this.updateAllCheckBoxes();
    }

    setInitialSelection = () => {
        let filtredItems = this.props.column.filteredItems;
        if (filtredItems) {
            for (let fi in filtredItems) {
                if (fi == "null") 
                    this.setCurrentItemsChecked(0, fi);
                else 
                    this.setCurrentItemsChecked(2, fi);
            }
        } else {
            this.setAllChecked();
        }
    }

    setCurrentItemsChecked = (level: number, value: string) => {
        var item = this.dateTreeView.nodes.filter(u => u.props.model.level == level && u.props.model.businessModel.value == value);
        if (item && item.length > 0) {
            item[0].select(true, true);
        }
    }

    setAllChecked() {
        var items = this.dateTreeView.nodes.filter(u => u.props.model.level == 0);
        if (items && items.length > 0) {
            for (let child of items) {
                child.select(true, true);
            }
        }
    }

    splitDate(value: any):any {
        return (value.name.split('T')[0].split('-'));
    }

    buildDateTree(item: ListItem) {
        let split = this.splitDate(item);
        let day = split[2];
        let month = split[1];
        let year = split[0];
        // year
        if (!this.years[year]) {
            this.years[year] = new YearFilterItem(year, year);
        }
        // month
        if (!this.years[year].months[month]) {
            this.years[year].months[month] = new MonthFilterItem(month, this.nameOfMonth(month), this.years[year]);
        }
        // day
        if (!this.years[year].months[month].days[day]) {
            this.years[year].months[month].days[day] = new DayFilterItem(item.name, day, this.years[year].months[month]);
        }
    }

    convertToDateModel() {
        this.model = new dateModel();
        let alleField = new dateModel();
        alleField.text = `${Resources.Common.selectAll}`;
        alleField.value = "@all@";
        alleField.childs = [];
        alleField.level = 1;
        this.model.childs.push(alleField);

        if (this.existNull) {
            let nullField = new dateModel();
            nullField.text = `${Resources.Common.null}`;
            nullField.value = "null";
            nullField.childs = [];
            nullField.level = 1;
            this.model.childs.push(nullField);
        }

        for (let y in this.years) {
            this.model.childs.push(this.createNewDateModel(this.years[y], this.years[y].months));
        }
    }

    // set childs of date model
    createChilds(item: any): dateModel[] {
        let childTrees: dateModel[] = [];
        for (let i in item) {
            childTrees.push(this.createNewDateModel(item[i], item[i].days));
        }
        return childTrees;
    }

    // create new date field (model)
    createNewDateModel(item: any, itemChild: any): dateModel {
        let newField = new dateModel();
        newField.text = item.name;
        newField.value = item.value;
        newField.childs = this.createChilds(itemChild).sort((a, b) => (a.value > b.value) ? 1 : -1);
        newField.level = item.level
        return newField;
    }

    nameOfMonth(month: string): string {
        switch (month) {
            case "01":
                return "Januar";
            case "02":
                return "Februar";
            case "03":
                return "März";
            case "04":
                return "April";
            case "05":
                return "Mai";
            case "06":
                return "Juni";
            case "07":
                return "Juli";
            case "08":
                return "August";
            case "09":
                return "September";
            case "10":
                return "Oktober";
            case "11":
                return "November";
            case "12":
                return "Dezember";
        }
        return "";
    }

    // update checked date in Treeview
    updateAllCheckBoxes() {
        this.checkBoxList = [];
        let checkAll = true;
        var allNode = this.dateTreeView.nodes.filter(u => u.props.model.level == 0 && u.props.model.businessModel.value == "@all@")
        var nullNode = this.dateTreeView.nodes.filter(u => u.props.model.level == 0 && u.props.model.businessModel.value == "null")
        var selectedItems = this.dateTreeView.nodes.filter(u => u.props.model.selected == 1 && u.props.model.businessModel.value != "@all@" && u.props.model.businessModel.value != "null");

        if (nullNode && nullNode.length > 0 && nullNode[0].props.model.selected == 1 && allNode[0].props.model.selected == 0) {
            checkAll = false;
            this.checkBoxList.push(nullNode[0].props.model.businessModel.value);
        }

        if (selectedItems.length > 0 && allNode[0].props.model.selected == 0) {
            this.checkBoxList = [];
            checkAll = false;
            for (let node of selectedItems) {
                if (node.props.level == 0) {
                    var months = node.props.model.children;
                    for (let month in months) {
                        var days = node.props.model.children[month].children;
                        for (let day in days) {
                            let date = days[day].businessModel.value.split('T')[0];
                            this.checkBoxList.push(date);
                        }
                    }
                }
                if (node.props.level == 1) {
                    var days = node.props.model.children;
                    for (let day in days) {
                        if (!this.isAddToList(days[day].businessModel.value)) {
                            let date = days[day].businessModel.value.split('T')[0];
                            this.checkBoxList.push(date);
                        }
                    }
                }
                if (node.props.level == 2) {
                    if (!this.isAddToList(node.props.model.businessModel.value)) {
                        let date = node.props.model.businessModel.value.split('T')[0];
                        this.checkBoxList.push(date);
                    }
                }
            }
        }
        if (checkAll || this.checkBoxList.length == 0)
          this.checkBoxList[0] = "@all@";
    }

    // check if date is in checkedList
    isAddToList(value: string): boolean {
        for (var i = 1; i < this.checkBoxList.length; i++) {
            if (this.checkBoxList[i] == value) {
                return true;
            }
        }
        return false;
    }


    public filterTree = (searchTerm: string) => {
        this.dateTreeView.props.filter = this.dateFilter;
        this.dateTreeView.filterTree(searchTerm, 0, 2);

        // update checkbox values
        this.dateTreeView.nodes.forEach(n => n.unselect(true, true));
        var visibleNodes = this.dateTreeView.nodes.filter(u => u.props.model.visible == true);
        if (visibleNodes != null && visibleNodes.length > 0) {
            var days = visibleNodes.filter(u => u.props.model.level == 2);
            if (days) {
                for (let day of days) {
                    day.props.model.selected = CheckedState.Checked;
                    day.select(true, true);
                }
            }
            this.updateAllCheckBoxes();
        }
    }

}

